import styles from './result-table-styles.module.css';

interface ResultTableMiddleProps {
    children: any;
}

const ResultTableMiddle = ({ children }: ResultTableMiddleProps) => {
    return (
        <div className={styles.tableCenter}>
            {children}

            {/*<div className={styles.actions}></div>*/}
        </div>
    );
};

export default ResultTableMiddle;
